<template>
  <path
    d="M18 2.00018H6C4.9 2.00018 4 2.90018 4 4.00018V20.0002C4 21.1002 4.9 22.0002 6 22.0002H18C19.1 22.0002 20 21.1002 20 20.0002V4.00018C20 2.90018 19.1 2.00018 18 2.00018ZM6 4.00018H11V12.0002L8.5 10.5002L6 12.0002V4.00018Z"
  />
</template>
